import {v4 as uuid4} from 'uuid';
import moment from "moment/moment";
import {List, Map} from "immutable";
import {images} from '../../common/components/images';

/* Domain */
import getDomainEnv from '../../domains/utils';
const env = getDomainEnv();

const randomNumber = () => {return Math.floor(Math.random() * 100)+1};

const sampleNextSession = {
    "description": "test",
    "end": moment().add(15, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
    "id": 389,
    "isoDate": "2020-09-22",
    "phone": "617-380-4313",
    "purchaseToken": "782-KbTpDpY3IWtq0EC9kA9enWSi5IDh2PJzahxZ9w-44",
    "remoteUserId": 782,
    "remoteUserName": "Jason A.",
    "room": "221055",
    "start": moment().add(14, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
    "thisUserId": 24324,
    "thisUserName": "Jason Aronson",
    "thisUserPlatform": "coach",
    "title": "Jason A.",
    "topic": "Test meeting 1",
    "videoAccessToken": null,
    "videoLinkClicked": false,
    "videoLinkSent": true,
    "videoStatus": "conference_ongoing",
    "videoUrl": "782-0WrmbjYDoFFE_iVTRfNhsn1N_xI7rJk_vp3qzA-44",
    "wmcId": 1
};

const sampleLastSession = {
    "description": "test",
    "end": moment().subtract(36, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
    "id": 389,
    "isoDate": "2020-09-22",
    "phone": "617-380-4313",
    "purchaseToken": "782-KbTpDpY3IWtq0EC9kA9enWSi5IDh2PJzahxZ9w-44",
    "remoteUserId": 782,
    "remoteUserName": "Jason A.",
    "room": "221055",
    "start": moment().subtract(37, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
    "thisUserId": 24324,
    "thisUserName": "Jason Aronson",
    "thisUserPlatform": "coach",
    "title": "Jason A.",
    "topic": "Test meeting 1",
    "videoAccessToken": null,
    "videoLinkClicked": false,
    "videoLinkSent": true,
    "videoStatus": "conference_ongoing",
    "videoUrl": "782-0WrmbjYDoFFE_iVTRfNhsn1N_xI7rJk_vp3qzA-44",
    "wmcId": 1
};

/* Middleware - tryGetEnterpriseClients */
export const devEnterpriseClientsData = {
    "prospects": [
        {
            "nextSession": sampleNextSession, // Not scheduled = null
            "lastSession": null, // New clients = null,
            "canceledFirstCall": false,
            "isArchived": false,
            "referralType": "wmc",
            "prospectId": 1,
            "coachId": 12,
            "coachProspectStatusId": 1,
            "coachProspectStatusTitle": "client",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 94,
            "email": "lily+testlength123+new@gmail.com",
            "firstName": "Lily",
            "lastName": "Riche",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
            ],
            "lastSessions": [
                sampleNextSession,
                sampleLastSession
            ],
            "nextSessions": [
                sampleNextSession,
                sampleLastSession
            ]
        },
        {
            "nextSession": null,
            "lastSession": sampleLastSession,
            "canceledFirstCall": false,
            "isArchived": false,
            "referralType": "willow",
            "prospectId": 1,
            "coachId": 12,
            "coachProspectStatusId": 1,
            "coachProspectStatusTitle": "client",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 95,
            "email": "ivan@gmail.com",
            "firstName": "Ivan",
            "lastName": "Mitrovic",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "advisor": null,
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "client"}
            ],
            "lastSessions": [
                sampleNextSession,
                sampleLastSession
            ],
            "nextSessions": [
                sampleNextSession,
                sampleLastSession
            ]
        },
        {
            "nextSession": sampleNextSession,
            "lastSession": sampleLastSession,
            "canceledFirstCall": false,
            "isArchived": false,
            "referralType": "willow",
            "prospectId": 1,
            "coachId": 12,
            "coachProspectStatusId": 1,
            "coachProspectStatusTitle": "client",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 96,
            "email": "sarah@gmail.com",
            "firstName": "Sarah",
            "lastName": "Sanders",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
            ],
            "lastSessions": [
                sampleNextSession,
                sampleLastSession
            ],
            "nextSessions": [
                sampleNextSession,
                sampleLastSession
            ]
        },
        {
            "nextSession": null,
            "lastSession": sampleLastSession,
            "canceledFirstCall": false,
            "isArchived": true,
            "referralType": "willow",
            "prospectId": 1,
            "coachId": 12,
            "coachProspectStatusId": 1,
            "coachProspectStatusTitle": "client",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 97,
            "email": "Terra@gmail.com",
            "firstName": "Terra",
            "lastName": "Pots",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
            ],
            "lastSessions": [
                sampleNextSession,
                sampleLastSession
            ],
            "nextSessions": [
                sampleNextSession,
                sampleLastSession
            ]
        }
    ],
    "past": []
};

/* Middleware - tryGetEnterpriseClientProgram */
export const devEnterpriseClientProgramData = {
    "program": {
        "package": "trial", // "1-month", "3-month", "6-month", "12-month subscription", or "trial"
        "purchaseDate": "2020-03-06T10:00:00+00:00",
        "completedSessions": 3,
        "remainingSessions": 3,
        "hoursInCoaching": 1.5,
        "lifeJourney": "Career"
    },
    "topic": "Most pressing question",
    "upcomingCall": "2020-05-24T10:00:00+00:00",
    "pastCalls": [
        {
            "id": 1,
            "date": "2020-04-12T10:00:00+00:00",
            "length": "30 min"
        },
        {
            "id": 2,
            "date": "2020-03-06T10:00:00+00:00",
            "length": "30 min"
        },
        {
            "id": 3,
            "date": "2020-02-25T10:00:00+00:00",
            "length": "30 min"
        }
    ]
};

export const devEnterpriseClientPurchaseLink = {
    "purchaseToken": null,
    "purchaseUrl": "https://google.com/123"
};

/* Middleware - tryGetEnterpriseClientAbout */
export const devEnterpriseClientAboutData = {
    "aboutData": [
        {
            "question": "Assets",
            "answer": "$250,000"
        },
        {
            "question": "Relationship",
            "answer": "Married/partnership"
        },
        {
            "question": "Working",
            "answer": "Full-time"
        },
        {
            "question": "Children",
            "answer": "No"
        }
    ]
};

/* Middleware - tryGetEnterpriseClientBalances */
export const devEnterpriseClientBalancesData = {
    "status": "connected_to_plaid", // "not_connected_to_plaid", "connected_to_plaid"
    "summary": {
        "refreshedOn": "2020-05-24T10:00:00+00:00",
        "netWorth": "$105,345"
    },
    "depositoryAccounts": [
        {
            "id": 3,
            "name": "ABC Account",
            "institutionName": "Bank of America",
            "balances": {
                "available": "$52,434"
            }
        }
    ],
    "investmentAccounts": [
        {
            "id": 1,
            "name": "ZYX Account",
            "institutionName": "Fidelity",
            "balances": {
                "current": "$5,534"
            }
        },
        {
            "id": 2,
            "name": "GHF Account",
            "institutionName": "Fidelity",
            "balances": {
                "current": "$20,544"
            }
        }
    ]
};

/* Middleware - tryGetEnterpriseClientGoals */
export const devEnterpriseClientGoalsData = [
    {
        "id": 1,
        "title": "Saving for a downpayment",
        "data": [
            {
                "id": 1,
                "description": "Need",
                "goal": "$250,000"
            },
            {
                "id": 2,
                "description": "Have",
                "goal": "$100,000"
            },
            {
                "id": 3,
                "description": "Saving (monthly)",
                "goal": "$2,000"
            },
            {
                "id": 4,
                "description": "Saving (annual)",
                "goal": "$24,000"
            },
            {
                "id": 5,
                "description": "Complete",
                "goal": "July 22, 2026"
            }
        ]
    },
    {
        "id": 6,
        "title": "Sarah's college",
        "data": [
            {
                "id": 7,
                "description": "Need",
                "goal": "$400,000"
            },
            {
                "id": 8,
                "description": "Have",
                "goal": "$20,000"
            },
            {
                "id": 11,
                "description": "Saving (monthly)",
                "goal": "$1,000"
            },
            {
                "id": 9,
                "description": "Saving (annual)",
                "goal": "$12,000"
            },
            {
                "id": 10,
                "description": "Complete",
                "goal": "August 1, 2032"
            }
        ]
    }
];

/* Middleware - tryGetEnterpriseClientNotes */
export const devEnterpriseClientNotesData = {
    "userNotes": [
        {
            "id": 1,
            "title": "Title",
            "body": "Note body test 1",
            "datetime": "2020-05-24T10:00:00+00:00"
        },
        {
            "id": 2,
            "title": "Title This one",
            "body": "Note body test 2",
            "datetime": "2020-05-27T10:00:00+00:00"
        }
    ]
};

/* Middleware - tryGetEnterpriseScheduleAvailability */
export const devEnterpriseScheduleAvailabilityData = {
    "availabilityTimeslots": [
        {
            id: uuid4(),
            start: "2020-09-19T13:00:00+00:00",
            end: "2020-09-19T15:00:00+00:00"
        },
        {
            id: uuid4(),
            start: "2020-09-20T16:00:00+00:00",
            end: "2020-09-20T22:00:00+00:00"
        }
    ]
};

export const devEnterpriseScheduleSessionsForwardData = {
    "sessions": [
        {
            id: uuid4(),
            remoteUserName: "Jason",
            remoteUserId: 1,
            thisUserName: "Jason Aronson",
            thisUserPlatform: "enterprise",
            start: "2021-10-25T04:00:00+00:00",
            end: "2021-10-25T04:30:00+00:00",
            expected_end: "2021-10-25T06:30:00+00:00",
            phone: "617-380-4313",
            room: "277861",
            videoStatus: "conference_ongoing", // conference_canceled, conference_ended, conference_has_not_yet_started, conference_ongoing
            videoUrl: "924fcf54447903ab9ea558886af67543", // if status !== conference_ongoing then videoUrl = null
            videoAccessToken: "abc", // if status !== conference_ongoing then videoAccessToken = null
            title: 'Jason Aronson',
            guests: []
        },
        {
            id: uuid4(),
            remoteUserName: "Jason",
            remoteUserId: 1,
            thisUserName: "Jason Aronson",
            thisUserPlatform: "enterprise",
            start: "2021-11-25T18:00:00+00:00",
            end: "2021-11-25T18:30:00+00:00",
            expected_end: "2021-11-25T21:30:00+00:00",
            phone: "617-380-4313",
            room: "277861",
            videoStatus: "conference_ongoing", // conference_canceled, conference_ended, conference_has_not_yet_started, conference_ongoing
            videoUrl: "924fcf54447903ab9ea558886af67543", // if status !== conference_ongoing then videoUrl = null
            videoAccessToken: "abc", // if status !== conference_ongoing then videoAccessToken = null
            title: 'Jason Aronson',
            guests: [
                {
                    "advisor": {
                        "email": "jason+test@"+env.URL.DOMAIN,
                        "firstName": "Jason",
                        "id": 900,
                        "lastName": "Aronson",
                        "phone": 4135193519,
                        "timeZone": "eastern",
                    },
                    "businessUserId": null,
                    "coachProspectStatusTitle": "undefined",
                    "consumerId": 969,
                    "email": "jason.aronson+nancy@gmail.com",
                    "expertId": 900,
                    "firstName": "Nancy",
                    "id": 105,
                    "isArchived": false,
                    "lastName": "Aronson",
                    "phone": "4132628977",
                    "prospectId": 418,
                    "referralType": "wmc",
                    "timeZone": "eastern",
                    "wmcId": 3,
                }
            ]
        }
    ]
};

/* Middleware - tryPostEnterpriseScheduleAvailability */
export const devEnterpriseScheduleAvailabilityAddData = (start, end) => ({
    "availabilityTimeslots": [
        {
            id: uuid4(),
            start: "2020-05-15T12:00:00+00:00",
            end: "2020-05-15T18:00:00+00:00"
        },
        {
            id: uuid4(),
            start: "2020-05-16T16:00:00+00:00",
            end: "2020-05-16T22:00:00+00:00"
        },
        {
            id: uuid4(),
            start: moment(start).format().toString(),
            end: moment(end).format().toString()
        }
    ]
});

/* Middleware - tryPutEnterpriseScheduleAvailability */
export const devEnterpriseScheduleAvailabilityUpdateData = (id, start, end, getState) => {
    const updatedAvailability = getState.enterprise.availability.get("availability").map(a => {
        if(a.get("id") === id) {
            return ({id: id, start: start, end: end})
        } else {
            return ({ id: a.get("id"), start: a.get("start"), end: a.get("end")})
        }
    });
    return ({"availabilityTimeslots": updatedAvailability.toJS()});
};

/* Middleware - tryDeleteEnterpriseScheduleAvailability */
export const devEnterpriseScheduleAvailabilityDeleteData = (id, getState) => {
    const deletedAvailability = getState.enterprise.availability.get("availability").filter(a => {
        return(a.get("id") !== id)
    });
    return ({"availabilityTimeslots": deletedAvailability.toJS()});
};

/* Middleware - tryGetSettingsEnterpriseSchedule */
export const devSettingsEnterpriseVacationData = {
    "isOnVacation": false
};

/* Middleware - tryUpdateSettingsEnterpriseSchedule */
export const devSettingsEnterpriseVacationUpdateData = (data) => ({
    "vacation": data.vacation
});

/* Middleware - tryGetSettingsEnterpriseNotifications */
export const devSettingsEnterpriseNotificationsData = {
    "emailAllowed": true,
    "smsAllowed": true,
};

/* Middleware - tryUpdateSettingsEnterpriseNotifications */
export const devSettingsEnterpriseNotificationsUpdateData = (data) => ({
    "emailAllowed": data.emailAllowed,
    "smsAllowed": data.smsAllowed
});

/* Middleware - tryGetSettingsEnterpriseTerms */
export const devSettingsEnterpriseTermsData = {
    "rate": 100,
    "maxClients": 20
};

/* Middleware - tryUpdateSettingsEnterpriseTerms */
export const devSettingsEnterpriseTermsUpdateData = (data) => ({
    "rate": data.rate,
    "maxClients": data.maxClients
});

/* Middleware - tryGetSettingsEnterpriseProfile */
// coachingcert, advancedDegree, otherEducation
export const devSettingsEnterpriseProfileData = {
    id: '32',

    firstName: "Jason",
    lastName: "Aronson",
    companyName: 'Coaching, LLC',
    crd: 'test 5',

    photo: images.devDataTeamJasonAvatar,
    introVideoUrl: 'https://www.youtube.com/embed/RZAF1DAqHPk',
    facebookUrl: 'https://facebook.com',
    linkedinUrl: 'https://linkedin.com',
    twitterUrl: 'https://twitter.com',
    address1: 'test 3',
    address2: 'test 6',
    city: 'Boston',
    state: 'MA',
    zipCode: '23443',
    bio: '<p>In an age of pandemic, what true value do any of our backgrounds hold? It’s not like we can look at precedents and say, people who have done ABC tend to be really successful at accomplishing XYZ in a pandemic. My expf</p>',

    // BEG COACH ONLY FIELDS
    endorsement1: 'Test 1',
    endorsement2: 'Test 2',
    endorsement3: null,
    freeTime: 'Test 7',
    whyBecameCoach: 'Test 2',
    coachPhilosophy: 'Test 3',
    highlights: 'Test 1',

    coachingCertification: null,
    coachingCertificationYear: null,

    // END COACH ONLY FIELDS

    bookingAvailability: 'available',

    screeningCallLength: 30,
    defaultCallLength: 30,

    advancedDegree: null,
    advancedDegreeCity: null,
    advancedDegreeInstitution: null,
    advancedDegreeState: null,
    advancedDegreeYear: null,

    otherEducation: null,

    expertCategories: [],

    storeActive: false,
    storeShowScheduler: true,
    storeShowEmailer: true,
    storeTitle: "",
    storePhoto: null,
    storeHandle: "samplestore",

    publicHandle: "sampleadvisor",
    profileActive: true,
    profileShowScheduler: true,
    profileShowEmailer: true,
    website: "fromjason.c",

    schedulerActive: true,
    schedulerHandle: "sampleschedule"
};

/* Middleware - tryUpdateSettingsEnterpriseProfile */
export const devSettingsEnterpriseProfileUpdateData = (data) => ({
    'photo': images.devDataTeamJasonAvatar,
    // "highlights": data.highlights,
    "bio": data.bio,
    "whyBecameCoach": data.whyBecameCoach,
    // "coachPhilosophy": data.coachPhilosophy,
    "companyName": data.companyName,
    "crd": data.crd,
    "endorsement1": data.endorsement1,
    "endorsement2": data.endorsement2,
    "endorsement3": data.endorsement3,
    "freeTime": data.freeTime,
    "address1": data.address1,
    "address2": data.address2,
    "city": data.city,
    "state": data.state,
    "zipCode": data.zipCode,
    "introVideoUrl": data.introVideoUrl,
    "facebookUrl": data.facebookUrl,
    "linkedinUrl": data.linkedinUrl,
    "twitterUrl": data.twitterUrl,
    "bookingAvailability": data.bookingAvailability
});

/* Middleware - tryGetSettingsEnterpriseClients */
export const devSettingsEnterpriseClientsData = {
    "journey": [
        {"id": 1, "question": "Going through a divorce", "specialist": true, "comfortable": false, "personal": false, "exclude": false},
        {"id": 2, "question": "Living as a widow", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 3, "question": "Caregiver for aging loved ones", "specialist": true, "comfortable": false, "personal": false, "exclude": false},
        {"id": 4, "question": "In charge of my family finances", "specialist": true, "comfortable": true, "personal": false, "exclude": false},
        {"id": 5, "question": "A single parent", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 6, "question": "Navigating my career", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 7, "question": "Starting out financially", "specialist": false, "comfortable": false, "personal": false, "exclude": true}
    ],
    "goal": [
        {"id": 1, "question": "Organizing my finances", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 2, "question": "Budgeting and paying bills", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 3, "question": "Improve my credit score", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 4, "question": "Reducing debt", "specialist": false, "comfortable": false, "personal": true, "exclude": false},
        {"id": 5, "question": "Easing financial stress and anxiety", "specialist": true, "comfortable": false, "personal": false, "exclude": false},
        {"id": 6, "question": "Planning for after I'm gone", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 7, "question": "Workplace benefits and insurance", "specialist": false, "comfortable": true, "personal": true, "exclude": false},
        {"id": 8, "question": "Saving for education and future expenses", "specialist": false, "comfortable": false, "personal": false, "exclude": true},
        {"id": 9, "question": "Improving or changing my career", "specialist": false, "comfortable": true, "personal": false, "exclude": false},
        {"id": 10, "question": "Considering a real estate purchase or rental", "specialist": true, "comfortable": false, "personal": false, "exclude": false},
        {"id": 11, "question": "Changing finances in a relationship", "specialist": false, "comfortable": true, "personal": true, "exclude": false}
    ],
    "approach": [
        {"id": 1, "question": "Understands the life of a military family", "resonates": true, "exclude": false},
        {"id": 2, "question": "Integrates spirituality into coaching", "resonates": false, "exclude": true},
        {"id": 3, "question": "Has a no-nonsense approach", "resonates": false, "exclude": false},
        {"id": 4, "question": "Knows what its like to be part of a minority community", "resonates": false, "exclude": false},
        {"id": 5, "question": "Emphasizes the emotional aspects of personal finance", "resonates": false, "exclude": false}
    ]
};

/* Middleware - tryUpdateSettingsEnterpriseClients */
export const devSettingsEnterpriseClientsUpdateData = (data) => data;

/* Middleware - tryGetSettingsEnterprisePayments */
export const devSettingsEnterpriseBankData = {
    "name": 'Jason Corporation',
    "routing": '***235',
    "account": '***232',
    "type": 'checking',
};

/* Middleware - tryUpdateSettingsEnterprisePayments */
export const devSettingsEnterpriseBankUpdateData = (data) => ({
    "name": data.name,
    "routing": data.routing,
    "account": data.account,
    "type": data.type
});

/* Middleware - Calendar Sync ("willow", "google_calendar", "microsoft_outlook") */
export const devSettingsEnterpriseCalendarSyncData = {
    "id": 12,
    "availability_calendar_update_method": "willow",
    "outlook_proxy": "testemail@outlook.com"
};

export const devSettingsEnterpriseCalendarSyncUpdateData = (syncMethod) => ({
    "id": 12,
    "availability_calendar_update_method": syncMethod
});

export const devSettingsEnterpriseCalendarSyncScheduleData = {
    "workSchedule": [
        {
            "dayOfWeek": "mon",
            "startTime": "12:00:00",
            "endTime": "13:00:00"
        },
        {
            "dayOfWeek": "tue",
            "startTime": "12:00:00",
            "endTime": "13:00:00"
        },
        {
            "dayOfWeek": "wed",
            "startTime": "12:00:00",
            "endTime": "13:00:00"
        },
        {
            "dayOfWeek": "thu",
            "startTime": "12:00:00",
            "endTime": "13:00:00"
        },
        {
            "dayOfWeek": "fri",
            "startTime": "12:00:00",
            "endTime": "13:00:00"
        }
    ]
};

export const devSettingsEnterpriseCalendarSyncScheduleUpdateData = (workSchedule) => ({
    "workSchedule": workSchedule
});


export const devEnterpriseProspectStageData = (prospectStages) => {
    if(prospectStages.size === 0) {
        return({"prospectStatusTypes": [
            devEnterpriseProspectStageCreateData(218, "Initial Call", 1),
            devEnterpriseProspectStageCreateData(219, "Considering", 1),
            devEnterpriseProspectStageCreateData(220, "Has paperwork", 1),
            devEnterpriseProspectStageCreateData(217, "undefined", 1),
            devEnterpriseProspectStageCreateData(randomNumber(), "client", 1)
        ]})
    } else {
        return({"prospectStatusTypes": prospectStages.toJS()})
    }
};

export const devEnterpriseProspectStageCreateData = (id, title, length) => ({
    "id": id,
    "title": title,
    "orderIndex": length,
    "isDelete": false
});

export const devEnterpriseProspectListData = {
    "prospects": [
        {
            "prospectId": 1,
            "coachId": 12,
            "coachProspectStatusId": null,
            "coachProspectStatusTitle": "",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 817,
            "email": "lily@gmail.com",
            "firstName": "Lily",
            "lastName": "Riche",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "nextSession": null, // Not scheduled = null
            "lastSession": null, // New clients = null,
            "canceledFirstCall": false,
            "isArchived": false,
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
            ],
            "lastSessions": [
                sampleNextSession,
                sampleLastSession
            ],
            "nextSessions": [
                sampleNextSession,
                sampleLastSession
            ]
        },
        {
            "prospectId": 2,
            "coachId": 12,
            "coachProspectStatusId": null,
            "coachProspectStatusTitle": "",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 106,
            "email": "sarah@gmail.com",
            "firstName": "Sarah",
            "lastName": "Preston",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "nextSession": sampleNextSession, // Not scheduled = null
            "lastSession": null, // New clients = null,
            "canceledFirstCall": false,
            "isArchived": false,
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Lacy",
                "id": 815,
                "lastName": "Garcia",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
            ],
            "lastSessions": [],
            "nextSessions": []
        },
        {
            "prospectId": 3,
            "coachId": 12,
            "coachProspectStatusId": null,
            "coachProspectStatusTitle": "",
            "statusNote": "",
            "statusOrderIndex": null,
            "consumerId": 105,
            "email": "sarah@gmail.com",
            "firstName": "Sarah",
            "lastName": "Preston",
            "phone": 1231231234,
            "registeredOn": null,
            "sentInvitationsCount": 0,
            "nextSession": sampleNextSession, // Not scheduled = null
            "lastSession": sampleLastSession, // New clients = null,
            "canceledFirstCall": false,
            "isArchived": false,
            "referralType": "willow",
            "advisor": null,
            "prospectStatuses": [
                {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
            ],
            "lastSessions": [
                sampleLastSession
            ],
            "nextSessions": [
                sampleNextSession
            ]
        }
    ]
};

export const devEnterpriseCreateProspectData = (first, last, email, phone, timeZone, revenue, probabilityOfClosing, companyName) => ({
    "prospectId": randomNumber(),
    "coachId": randomNumber(),
    "consumerId": randomNumber(),
    "contactId": randomNumber(),
    "email": email,
    "firstName": first,
    "lastName": last,
    "phone": phone,
    "registeredOn": null,
    "coachProspectStatusId": null,
    "coachProspectStatusTitle": "undefined",
    "statusNote": "",
    "statusOrderIndex": null,
    "sentInvitationsCount": 0,
    "nextSession": null, // Not scheduled = null
    "lastSession": null, // New clients = null,
    "canceledFirstCall": false,
    "isArchived": false,
    "referralType": "wmc",
    "timeZone": timeZone,
    "advisor": {
        "email": "gabby@hotmail.com",
        "firstName": "Lacy",
        "id": 815,
        "lastName": "Garcia",
        "phone": 7742580278,
        "timeZone": "eastern"
    },
    "prospectStatuses": [
        {statusId: 586, statusTypeId: 217, expertId: 24324, wmcId: 1, title: "Identified"}
    ],
    "revenue": revenue,
    "probabilityOfClosing": probabilityOfClosing,
    "companyName": companyName,
    "wmcId":3,
    "rateFee":"0",
    "assignedCoaches":[
        {
            "coachId":900,
            "wmcId":3,
            "first":"Jason",
            "last":"Advisor 900",
            "phone":4135193519,
            "email":"jason@"+env.URL.DOMAIN,
            "photo":images.devDataTeamJasonAvatar,
            "defaultCallLengthInMinutes":30,
            "storeActive":true,
            "storeHandle":"jasonaronson-advisor",
            "bio":"<p>Jason is a quant, full-stack developer, CFA Charterholder, and all-around data geek. He helped create Empirical Asset Management, a wealth management firm delivering emotion-free rules-based portfolios to investors, institutions, and advisors. At Empirical, Jason built the firm\u2019s research and trading platforms, back-office operations, managed equity portfolios including a machine learning driven multi-factor ESG strategy, and helped individuals and families achieve their financial goals.</p><p><br></p><p>Prior to Empirical, Jason was a quant working at Santander in solvency risk for the $20B commercial real estate loan portfolio. Prior to Santander, he worked in risk management and actuarial at Covery\u2019s where Jason built a product using clustering to assess the quality of insured doctors.</p><p><br></p><p>Jason holds a MS in Quantitative Finance from Bentley University and a BS in Computational Finance and Computer Science from Babson College.</p>",
            "expertCategories":[
                {
                    "categoryId":2,
                    "categoryName":"Financial Advisor"
                }
            ]
        }
    ],
    "nextSessions":[],
    "lastSessions":[],
});

export const devSettingsEnterpriseHandleData = (isFound, handle) => {
    if(isFound) {
        return({
            "id": 12,
            "publicHandle": handle,
            "expertCategoryName": "coach", // coach, advisor, etc
            "expertCategoryId": 1
        })
    } else {
        return({
            "error": "Public handle can not be found",
            "errorDetails": "Expert does not exist"
        })
    }
};

const sampleMessagesArray = [
    {
        "channel": "email",
        "content": "<p>Test email</p>",
        "formattedDatetime": "2020-09-22T19:45:48.178220+00:00",
        "fromUserId": 44,
        "id": 1148,
        "isFromAdvisor": true,
        "isFromLily": false,
        "isoDate": "2020-09-22",
        "subject": "Test email"
    },
    {
        "channel": "sms",
        "content": "Test!",
        "formattedDatetime": "2020-09-22T20:40:06.488418+00:00",
        "fromUserId": 44,
        "id": 1150,
        "isFromAdvisor": true,
        "isFromLily": false,
        "isoDate": "2020-09-22",
        "subject": ""
    },
    {
        "channel": "chat",
        "content": "From video page",
        "formattedDatetime": "2020-09-22T20:40:06.488418+00:00",
        "fromUserId": 44,
        "id": 1150,
        "isFromAdvisor": true,
        "isFromLily": false,
        "isoDate": "2020-09-22",
        "subject": ""
    },
    {
        "channel": "email",
        "content": "<p>Reply email</p>",
        "formattedDatetime": "2020-09-22T19:45:48.178220+00:00",
        "fromUserId": 44,
        "id": 1148,
        "isFromAdvisor": false,
        "isFromLily": true,
        "isoDate": "2020-09-22",
        "subject": "RE: Test email"
    },
    {
        "channel": "sms",
        "content": "Reply text!",
        "formattedDatetime": "2020-09-22T20:40:06.488418+00:00",
        "fromUserId": 44,
        "id": 1150,
        "isFromAdvisor": false,
        "isFromLily": true,
        "isoDate": "2020-09-22",
        "subject": ""
    },
    {
        "channel": "chat",
        "content": "Reply from video page",
        "formattedDatetime": "2020-09-22T20:40:06.488418+00:00",
        "fromUserId": 44,
        "id": 1150,
        "isFromAdvisor": false,
        "isFromLily": true,
        "isoDate": "2020-09-22",
        "subject": ""
    },
    {
        "channel": "form",
        "content": "[{\"pageNum\":0,\"header\":{\"title\":\"Help your financial coach prepare\"},\"actions\":{\"pageNumVisible\":true,\"backLabel\":\"\",\"nextLabel\":\"Continue\",\"canContinueAutomatically\":false},\"elements\":[{\"id\":\"1fff7698-37c7-4a0e-b572-8fed2062958c\",\"type\":\"checkbox\",\"title\":\"What challenges are you facing?\",\"body\":\"(check all that apply)\",\"maxCheckable\":null,\"isValid\":true,\"isRequired\":true,\"options\":[{\"id\":1,\"active\":true,\"label\":\"I'm navigating a divorce\"},{\"id\":2,\"active\":false,\"label\":\"I'm divorced\"},{\"id\":3,\"active\":false,\"label\":\"I'm a widow\"},{\"id\":4,\"active\":false,\"label\":\"I'm a caregiver for aging loved ones\"},{\"id\":5,\"active\":false,\"label\":\"I'm in charge of my family finances\"},{\"id\":6,\"active\":false,\"label\":\"I'm a single parent\"},{\"id\":7,\"active\":false,\"label\":\"I'm navigating my career\"},{\"id\":8,\"active\":false,\"label\":\"I'm starting out financially\"},{\"id\":9,\"active\":false,\"label\":\"I'm planning for retirement\"},{\"id\":10,\"active\":false,\"label\":\"I'm saving for other goals\"},{\"id\":11,\"active\":false,\"label\":\"I'm looking to grow my wealth\"}]}]},{\"pageNum\":1,\"header\":{\"title\":\"Help your financial coach prepare\"},\"actions\":{\"pageNumVisible\":true,\"backLabel\":\"Back\",\"nextLabel\":\"Continue\",\"canContinueAutomatically\":false},\"elements\":[{\"id\":\"67ed5efa-ae28-4edb-81b9-d5933ca28982\",\"type\":\"checkbox\",\"title\":\"What are your coaching goals?\",\"body\":\"(check all that apply)\",\"maxCheckable\":null,\"isValid\":true,\"isRequired\":true,\"options\":[{\"id\":1,\"active\":true,\"label\":\"Organize my finances\"},{\"id\":2,\"active\":false,\"label\":\"Budgeting and paying bills\"},{\"id\":3,\"active\":false,\"label\":\"Improve my credit score\"},{\"id\":4,\"active\":false,\"label\":\"Reduce debt\"},{\"id\":5,\"active\":false,\"label\":\"Easing financial stress and anxiety\"},{\"id\":6,\"active\":false,\"label\":\"Planning for after I'm gone\"},{\"id\":7,\"active\":false,\"label\":\"Workplace benefits and insurance\"},{\"id\":8,\"active\":false,\"label\":\"Saving for education and future expenses\"},{\"id\":9,\"active\":false,\"label\":\"Improving or changing my career\"},{\"id\":10,\"active\":false,\"label\":\"Considering a real estate purchase or rental\"},{\"id\":11,\"active\":false,\"label\":\"Changing finances in a relationship\"}]}]},{\"pageNum\":2,\"header\":{\"title\":\"Help your financial coach prepare\"},\"actions\":{\"pageNumVisible\":true,\"backLabel\":\"Back\",\"nextLabel\":\"Continue\",\"canContinueAutomatically\":false},\"elements\":[{\"id\":\"34a542a1-166b-45e2-acbc-2ae9307a0f0b\",\"type\":\"textarea\",\"isValid\":true,\"isRequired\":true,\"title\":\"Share your questions\",\"placeholder\":\"Tell your financial coach what they can help you with\",\"text\":\"dsafsdf\"}]},{\"pageNum\":3,\"header\":{\"title\":\"Help your financial coach prepare\"},\"actions\":{\"pageNumVisible\":true,\"backLabel\":\"Back\",\"nextLabel\":\"Continue\",\"canContinueAutomatically\":true},\"elements\":[{\"id\":\"51798fce-9783-4108-87df-f89e34ec0d77\",\"type\":\"specialCoaching\",\"title\":\"Our goal is to bring you the best match with a coach. Do any of these profiles resonate with you?\",\"body\":\"(optional, choose any)\",\"isRequired\":false,\"options\":[{\"id\":1,\"active\":false,\"icon\":\"coachstyle_military\",\"title\":\"Understands the life of a military family\",\"body\":\"They know the nuances between personal finance for civilians and those who are on active duty or have military backgrounds.\"},{\"id\":2,\"active\":true,\"icon\":\"coachstyle_nononsense\",\"title\":\"Has a no-nonsense approach\",\"body\":\"They're not afraid of straight talk and will deliver their message with tough love if needed.\"},{\"id\":3,\"active\":false,\"icon\":\"coachstyle_spiritual\",\"title\":\"Integrates spirituality into their coaching\",\"body\":\"They are comfortable talking about matters of faith and the intertwines with money\"},{\"id\":4,\"active\":false,\"icon\":\"coachstyle_emotional\",\"title\":\"Emphasizes the emotional aspects of personal finance\",\"body\":\"They'll help me reflect on my feelings about money and can understand that there is a lot beneath the surface when it comes to my history with money.\"},{\"id\":5,\"active\":false,\"icon\":\"coachstyle_underserved\",\"title\":\"Knows what it's like to be part of a minority community\",\"body\":\"They understand not all money experiences are the same and they\u2019re ready to help me forge my path forward.\"}],\"isValid\":true}]}]",
        "formattedDatetime": "2020-09-23T20:40:06.488418+00:00",
        "fromUserId": 44,
        "id": 1150,
        "isFromAdvisor": false,
        "isFromLily": true,
        "isoDate": "2020-09-22",
        "subject": ""
    }
];
const sampleNoteArray = [
    {
        body: "<p>Does this work?</p><p><br></p><p><strong>I'm going to render some html now:</strong></p><ul><li>Here is bullet 1</li><li>Here is bullet 2</li></ul><p><br></p><p><u>And here is the main point</u></p>",
        datetime: moment().format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        id: 142,
        isoDate: moment().format("YYYY-MM-DD"),
        title: "First note!"
    }
];

const sampleUpcomingCalls = [
    {
        "description": "test",
        "end": moment().add(7, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        "id": 3892,
        "isoDate": "2020-09-22",
        "phone": "617-380-4313",
        "purchaseToken": "782-KbTpDpY3IWtq0EC9kA9enWSi5IDh2PJzahxZ9w-44",
        "remoteUserId": 782,
        "remoteUserName": "Jason A.",
        "room": "221055",
        "start": moment().add(6, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        "thisUserId": 44,
        "thisUserName": "Jason Aronson",
        "thisUserPlatform": "coach",
        "title": "Jason A.",
        "topic": "Test meeting 1 upcoming",
        "videoAccessToken": null,
        "videoLinkClicked": false,
        "videoLinkSent": true,
        "videoStatus": "conference_ongoing",
        "videoUrl": "782-0WrmbjYDoFFE_iVTRfNhsn1N_xI7rJk_vp3qzA-44",
        "guests": [],
        "expected_end": null
    }
];

const sampleOngoingCalls = [
    {
        "description": "test",
        "end": moment().add(6, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        "id": 389,
        "isoDate": "2020-09-22",
        "phone": "617-380-4313",
        "purchaseToken": "782-KbTpDpY3IWtq0EC9kA9enWSi5IDh2PJzahxZ9w-44",
        "remoteUserId": 782,
        "remoteUserName": "Jason A.",
        "room": "221055",
        "start": moment().add(5, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        "thisUserId": 44,
        "thisUserName": "Jason Aronson",
        "thisUserPlatform": "coach",
        "title": "Jason A.",
        "topic": "Test meeting 1 ongoing",
        "videoAccessToken": null,
        "videoLinkClicked": false,
        "videoLinkSent": true,
        "videoStatus": "conference_ongoing",
        "videoUrl": "782-0WrmbjYDoFFE_iVTRfNhsn1N_xI7rJk_vp3qzA-44",
        "guests": [],
        "expected_end": null
    }
];

const samplePastCalls = [
    {
        "description": "test",
        "end": "2020-11-23T06:42:00+00:00",//moment().subtract(23, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        "id": 3894,
        "isoDate": "2020-09-22",
        "phone": "617-380-4313",
        "purchaseToken": "782-KbTpDpY3IWtq0EC9kA9enWSi5IDh2PJzahxZ9w-44",
        "remoteUserId": 782,
        "remoteUserName": "Jason A.",
        "room": "221055",
        "start": "2020-11-23T05:57:00+00:00", //moment().subtract(24, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
        "thisUserId": 44,
        "thisUserName": "Jason Aronson",
        "thisUserPlatform": "coach",
        "title": "Jason A.",
        "topic": "Test meeting 1 past",
        "videoAccessToken": null,
        "videoLinkClicked": false,
        "videoLinkSent": true,
        "videoStatus": "conference_ongoing",
        "videoUrl": "782-0WrmbjYDoFFE_iVTRfNhsn1N_xI7rJk_vp3qzA-44",
        "guests": [],
        "expected_end": "2020-11-23T06:42:00+00:00"
    },
];

const sampleCanceledCalls = [
    {
        "description": "",
        "end": "2020-11-24T06:41:00+00:00",
        "id": 3938,
        "isoDate": "2020-09-23",
        "missedByClient": true,
        "missedByCoach": true,
        "phone": "617-380-4313",
        "purchaseToken": "782-FYsf1N6ad1UzHDpTIyGweTY3AkdUSOEZWei5Ow-44",
        "remoteUserId": 782,
        "remoteUserName": "Jason Aronson",
        "room": "279268",
        "start": "2020-11-24T05:56:00+00:00",
        "thisUserId": 44,
        "thisUserName": "Jason Aronson",
        "thisUserPlatform": "coach",
        "title": "Jason A.",
        "topic": "Test meeting 1 canceled",
        "videoAccessToken": null,
        "videoLinkClicked": false,
        "videoLinkSent": false,
        "videoStatus": "conference_canceled",
        "videoUrl": null,
        "guests": [],
        "expected_end": "2020-11-24T06:41:00+00:00"
    },
];


export const devEnterpriseClientActivityData = {"days": [
    {
        "isoDate": moment().format("YYYY-MM-DD"),
        "userNotes": sampleNoteArray,
        "currentTasks": [], //sampleCurrentTasks,
        "completedTasks": [], //sampleCompletedTasks,
        "pastConferences": samplePastCalls,
        "ongoingConferences": sampleOngoingCalls,
        "upcomingConferences": sampleUpcomingCalls,
        "messages": sampleMessagesArray,
        "canceledConferences": sampleCanceledCalls
    },
    {
        "isoDate": moment().subtract(1, "day").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    },
    {
        "isoDate": moment().subtract(2, "days").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    },
    {
        "isoDate": moment().subtract(3, "days").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    },
    {
        "isoDate": moment().subtract(4, "days").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    },
    {
        "isoDate": moment().subtract(5, "days").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    },
    {
        "isoDate": moment().subtract(6, "days").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    },
    {
        "isoDate": moment().subtract(31, "days").format("YYYY-MM-DD"),
        "userNotes": [],
        "currentTasks": [],
        "completedTasks": [],
        "pastConferences": [],
        "ongoingConferences": [],
        "upcomingConferences": [],
        "messages": [],
        "canceledConferences": []
    }
]};

export const devEnterprisePublicHandle = (handle) => ({
    "publicHandle": handle
});

export const devSettingsUsersEmployeesCreate = (data) => ({
    "id": randomNumber(),
    "email": data.email,
    "firstName": data.first,
    "lastName": data.last,
    "phone": data.phone,
    "timeZone": data.timeZone,
    "photo": images.devDataTeamJasonAvatar,
    "bio": '<p>In an age of pandemic, what true value do any of our backgrounds hold? It’s not like we can look at precedents and say, people who have done ABC tend to be really successful at accomplishing XYZ in a pandemic. My expf</p>',
    "whyBecameCoach": 'Test 2',
    "companyName": 'Coaching, LLC',
    "crd": 'test 5',
    "endorsement1": 'Test 1',
    "endorsement2": 'Test 2',
    "endorsement3": null,
    "freeTime": 'Test 7',
    "address1": 'test 3',
    "address2": 'test 6',
    "city": 'Boston',
    "state": 'MA',
    "zipCode": '23443',
    "introVideoUrl": 'https://google.com',
    "facebookUrl": 'https://facebook.com',
    "linkedinUrl": 'https://linkedin.com',
    "twitterUrl": 'https://twitter.com',
    "bookingAvailability": data.bookingAvailability === undefined ? "available" : data.bookingAvailability,
    "screeningCallLength": 30,
    "defaultCallLength": 30,
});

export const devSettingsUsersEmployees = {
    "employees": [
        devSettingsUsersEmployeesCreate({first: "Jason", last: "Aronson", phone: "4135193519", email: "jason.aronson@gmail.com", timeZone: "central", id: 1, "bookingAvailability": "available"}),
        devSettingsUsersEmployeesCreate({first: "Jason", last: "Aronson", phone: "4135193519", email: "jason.aronson@gmail.com", timeZone: "central", id: 2, "bookingAvailability": "not_available"}),
        devSettingsUsersEmployeesCreate({first: "Jason", last: "Aronson", phone: "4135193519", email: "jason.aronson@gmail.com", timeZone: "central", id: 3, "bookingAvailability": "available"})
    ]
};

export const devContacts = {
    "allContacts": [
        {
            "id": 5,
            "email": "jason@"+env.URL.DOMAIN,
            "phone": "4135193519",
            "firstName": "Jason",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 12,
            "wmcId": 1,
            "prospectId": 500,
            "isArchived": true,
            "coachProspectStatusTitle": "Client",
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "consumerId": 815
        },
        {
            "id": 6,
            "email": "jason.aronson@gmail.com",
            "phone": "6177808109",
            "firstName": "Jenna",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 13,
            "wmcId": 1,
            "prospectId": 501,
            "isArchived": false,
            "coachProspectStatusTitle": "Paperwork Sent",
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "consumerId": 816
        },
        {
            "id": 7,
            "email": "jason.aronson@gmail.com",
            "phone": "6177808109",
            "firstName": "Lauren",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 13,
            "wmcId": 1,
            "prospectId": null,
            "isArchived": false,
            "coachProspectStatusTitle": null,
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "consumerId": 817
        },
        {
            "id": 8,
            "email": "jason.aronson@gmail.com",
            "phone": "6177808109",
            "firstName": "Maple",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 12,
            "wmcId": 1,
            "prospectId": null,
            "isArchived": false,
            "coachProspectStatusTitle": null,
            "referralType": "willow",
            "advisor": null,
            "consumerId": 818
        }
    ]
};

export const devEnterpriseCreateContactData = (first, last, email, phone, timeZone, wmcId, expertId, prospectId, companyName) => ({
    "id": uuid4(),
    "email": email,
    "phone": phone,
    "firstName": first,
    "lastName": last,
    "timeZone": timeZone,
    "expertId": expertId,
    "wmcId": wmcId,
    "prospectId": prospectId,
    "isArchived": false,
    "coachProspectStatusTitle": null,
    "referralType": "wmc",
    "advisor": {
        "email": "gabby@hotmail.com",
        "firstName": "Gabby",
        "id": 815,
        "lastName": "Baker",
        "phone": 7742580278,
        "timeZone": "eastern"
    },
    "consumerId": null,
    "companyName": companyName
});

export const devEnterpriseEditContactData = (first, last, email, phone, timeZone, contactId, prospectId, prospectStage, companyName) => ({
    "id": contactId === null ? uuid4() : contactId,
    "email": email,
    "phone": phone,
    "firstName": first,
    "lastName": last,
    "timeZone": timeZone,
    "expertId": 1,
    "wmcId": 2,
    "prospectId": prospectId,
    "isArchived": false,
    "coachProspectStatusTitle": prospectStage,
    "referralType": "wmc",
    "advisor": {
        "email": "gabby@hotmail.com",
        "firstName": "Gabby",
        "id": 815,
        "lastName": "Baker",
        "phone": 7742580278,
        "timeZone": "eastern"
    },
    "consumerId": 820,
    "companyName": companyName
});

export const devProspectsWithoutContact = {
    "prospects": [
        {
            "email": "jason@"+env.URL.DOMAIN,
            "phone": "4135193519",
            "firstName": "Jason",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 12,
            "wmcId": 1,
            "prospectId": 500,
            "isArchived": true,
            "coachProspectStatusTitle": "Client",
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "consumerId": 821
        },
        {
            "email": "jason.aronson@gmail.com",
            "phone": "6177808109",
            "firstName": "Jenna",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 13,
            "wmcId": 1,
            "prospectId": 501,
            "isArchived": false,
            "coachProspectStatusTitle": "Paperwork Sent",
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "consumerId": 822
        },
        {
            "email": "jason.aronson@gmail.com",
            "phone": "6177808109",
            "firstName": "Lauren",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 13,
            "wmcId": 1,
            "prospectId": 462,
            "isArchived": false,
            "coachProspectStatusTitle": null,
            "referralType": "wmc",
            "advisor": {
                "email": "gabby@hotmail.com",
                "firstName": "Gabby",
                "id": 815,
                "lastName": "Baker",
                "phone": 7742580278,
                "timeZone": "eastern"
            },
            "consumerId": 823
        },
        {
            "email": "jason.aronson@gmail.com",
            "phone": "6177808109",
            "firstName": "Maple",
            "lastName": "Aronson",
            "timeZone": "eastern",
            "expertId": 12,
            "wmcId": 1,
            "prospectId": 887,
            "isArchived": false,
            "coachProspectStatusTitle": null,
            "referralType": "willow",
            "advisor": null,
            "consumerId": 824
        }
    ]
};

export const devEnterpriseGuestsOnMeeting = {
    allContacts: [
        {
            advisor: {
                email: "jason+test@"+env.URL.DOMAIN,
                firstName: "Jason",
                id: 900,
                lastName: "Aronson",
                phone: 4135193519,
                timeZone: "eastern",
            },
            coachProspectStatusTitle: "First meeting",
            consumerId: 918,
            email: "jason.aronson+jenna@gmail.com",
            expertId: 900,
            firstName: "Jim",
            id: 17,
            isArchived: false,
            lastName: "Aronson",
            phone: "6177808109",
            prospectId: 381,
            referralType: "wmc",
            timeZone: "eastern",
            wmcId: 3
        },
        {
            advisor: {
                email: "jason+test@"+env.URL.DOMAIN,
                firstName: "Jason",
                id: 900,
                lastName: "Aronson",
                phone: 4135193519,
                timeZone: "eastern",
            },
            coachProspectStatusTitle: "First meeting",
            consumerId: 919,
            email: "jason.aronson+nancy@gmail.com",
            expertId: 900,
            firstName: "Nancy",
            id: 18,
            isArchived: false,
            lastName: "Aronson",
            phone: "6177808109",
            prospectId: 382,
            referralType: "wmc",
            timeZone: "eastern",
            wmcId: 3
        }
    ]
};

export const devEnterpriseAllContacts = [
    {
        "contactId": 131,
        "firstName": "Jenna",
        "lastName": "Aronson",
        "isArchived": false,
        "businessUserId": null,
        "prospectId": 441,
        "consumerId": 782,
        "email": "jason.aronson@gmail.com",
        "phone": 8888888888,
        "prospectStatus": "Prospect",
        "memberOfGroups": null,
        "referralSource": "wmc",
        "timeZone": "eastern",
        "companyName": "",
        "address1":null,
        "address2":null,
        "assetEstimate":null,
        "city":null,
        "coachAssignments": [],
        "dateOfBirth":null,
        "expertFullName":"Jason Aronson",
        "expertId":900,
        "maritalStatus":null,
        "state":null,
        "zipCode":null,
    },
    {
        "contactId": 103,
        "firstName": "Maple",
        "lastName": "Aronson ",
        "isArchived": true,
        "businessUserId": null,
        "prospectId": 417,
        "consumerId": 968,
        "email": "jason.aronson@gmail.com",
        "phone": 8888888888,
        "prospectStatus": "Prospect",
        "memberOfGroups": null,
        "referralSource": "wmc",
        "timeZone": "eastern",
        "companyName": "One company",
        "address1":null,
        "address2":null,
        "assetEstimate":null,
        "city":null,
        "coachAssignments": [],
        "dateOfBirth":null,
        "expertFullName":"Jason Aronson",
        "expertId":900,
        "maritalStatus":null,
        "state":null,
        "zipCode":null,
    },
    {
        "contactId": 129,
        "firstName": "Lauren",
        "lastName": "Aronson",
        "isArchived": false,
        "businessUserId": null,
        "prospectId": 439,
        "consumerId": 998,
        "email": "jason.aronson@gmail.com",
        "phone": 8888888888,
        "prospectStatus": "Client",
        "memberOfGroups": null,
        "referralSource": "willow",
        "timeZone": "eastern",
        "companyName": "Two company",
        "address1":null,
        "address2":null,
        "assetEstimate":null,
        "city":null,
        "coachAssignments": [],
        "dateOfBirth":null,
        "expertFullName":"Jason Aronson",
        "expertId":900,
        "maritalStatus":null,
        "state":null,
        "zipCode":null,
    },
    {
        "contactId": 1529,
        "firstName": "Nancy",
        "lastName": "Aronson",
        "isArchived": false,
        "businessUserId": 243245,
        "prospectId": 4339,
        "consumerId": null,
        "email": "jason.aronson@gmail.com",
        "phone": 8888888888,
        "prospectStatus": null,
        "memberOfGroups": null,
        "referralSource": null,
        "timeZone": "eastern",
        "companyName": "Three company",
        "address1":null,
        "address2":null,
        "assetEstimate":null,
        "city":null,
        "coachAssignments": [],
        "dateOfBirth":null,
        "expertFullName":"Jason Aronson",
        "expertId":900,
        "maritalStatus":null,
        "state":null,
        "zipCode":null,
    }
];

export const devEnterpriseProspectV3 = {
    "contactId": 103,
    "consumerId": 10030,
    "firstName": "Jason",
    "lastName": "Aronson",
    "isArchived": true,
    "prospectId": 545,
    "prospectStageId": 217,
    "prospectStageName": "undefined",
    "advisor": {
        "advisorId": 42,
        "firstName": "Joe",
        "lastName": "Advisor"
    },
    "coaches": [],
    "nextSession": null,
    "lastSession": {"start": moment().subtract(45, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
    "memberOfGroups": null,
    "revenue": "0.00",
    "probabilityOfClosing": "30.00",
    "companyName": "Another company",
    "wmcId": 23,
    "isActive": true,
    "survey": [ { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"", "nextLabel":"Continue", "pageNumVisible":true, "canContinueAutomatically":false }, "pageNum":0, "elements":[ { "id":"66a4c954-7991-4e4d-a0cf-ce858a71b3d8", "type":"checkBox", "style":{ "options":{ }, "warning":{ }, "subtitle":{ }, "disclosure":{ }, "optionIcon":{ }, "optionLabel":{ } }, "isValid":true, "options":[ { "id":1, "label":"I'm going through a divorce", "active":false }, { "id":2, "label":"I'm a widow", "active":false }, { "id":3, "label":"I'm a caregiver for aging loved ones", "active":true }, { "id":4, "label":"I'm navigating a career change (exit or re-entry)", "active":false }, { "id":5, "label":"I'm in charge of my family finances", "active":false }, { "id":6, "label":"I'm a single parent", "active":false }, { "id":7, "label":"I'm part of a non-traditional relationship", "active":false }, { "id":8, "label":"I'm still starting out financially", "active":false }, { "id":9, "label":"I'm an entrepreneur", "active":false }, { "id":10, "label":"I'm navigating career challenges as an executive", "active":false }, { "id":11, "label":"Other", "active":false } ], "warning":"Required", "subtitle":"What Life Journey are you on?", "disclosure":"(check all that apply)", "isRequired":true, "maxCheckable":null } ] }, { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"Back", "nextLabel":"Continue", "pageNumVisible":true, "canContinueAutomatically":false }, "pageNum":1, "elements":[ { "id":"a5e6a31d-ebe3-46e4-bc5e-be33b07226d4", "type":"checkBox", "style":{ "options":{ }, "warning":{ }, "subtitle":{ }, "disclosure":{ }, "optionIcon":{ }, "optionLabel":{ } }, "isValid":true, "options":[ { "id":1, "label":"Financial organization", "active":false }, { "id":2, "label":"Cash flow management/budgeting", "active":false }, { "id":3, "label":"Debt management", "active":false }, { "id":4, "label":"Managing credit", "active":false }, { "id":5, "label":"Bill pay", "active":false }, { "id":6, "label":"Easing financial stress/anxiety", "active":false }, { "id":7, "label":"Insurance", "active":true }, { "id":8, "label":"Career decisions coaching/salary negotiations", "active":false }, { "id":9, "label":"Workplace benefits", "active":false }, { "id":10, "label":"Children expense planning", "active":false }, { "id":11, "label":"Education planning (i.e. college planning)", "active":false }, { "id":12, "label":"Relationships & marriage preparation (i.e. prenups, combining finances)", "active":false }, { "id":13, "label":"Fertility planning", "active":false }, { "id":14, "label":"Estate planning", "active":false }, { "id":15, "label":"Real estate decisions", "active":false }, { "id":16, "label":"Finding employment", "active":false }, { "id":17, "label":"Other", "active":false } ], "warning":"Required", "subtitle":" What are your Top 3 Financial Coaching goals? ", "disclosure":"(Please only check your top 3)", "isRequired":true, "maxCheckable":3 } ] }, { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"Back", "nextLabel":"Continue", "pageNumVisible":true, "canContinueAutomatically":false }, "pageNum":2, "elements":[ { "id":"5dbe5f6d-1c41-48ae-9dbb-31d4e824e1ce", "type":"radioBox", "style":{ "options":{ }, "warning":{ }, "subtitle":{ }, "disclosure":{ }, "optionIcon":{ }, "optionLabel":{ } }, "isValid":true, "options":[ { "id":1, "label":"Female", "active":false }, { "id":2, "label":"Male", "active":false }, { "id":3, "label":"No Preference", "active":true } ], "warning":"Required", "subtitle":"Do you have a preferred gender for your Financial Coach?", "disclosure":"", "isRequired":true, "maxCheckable":1 } ] }, { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"Back", "nextLabel":"Continue", "pageNumVisible":true, "canContinueAutomatically":false }, "pageNum":3, "elements":[ { "id":"01518d4c-2772-4d0c-96e6-0353b153394e", "type":"radioBox", "style":{ "options":{ }, "warning":{ }, "subtitle":{ }, "disclosure":{ }, "optionIcon":{ }, "optionLabel":{ } }, "isValid":true, "options":[ { "id":1, "label":"I\u2019m employed full-time", "active":false }, { "id":2, "label":"I\u2019m employed part-time", "active":true }, { "id":3, "label":"I\u2019m part of the gig economy (freelancer, contractor)", "active":false }, { "id":4, "label":"I\u2019m in between jobs at the moment", "active":false }, { "id":5, "label":"I\u2019m retired", "active":false }, { "id":6, "label":"I\u2019m semi-retired", "active":false }, { "id":7, "label":"I\u2019m a full-time homemaker", "active":false } ], "warning":"Required", "subtitle":"What is your current employment status? ", "disclosure":"", "isRequired":true, "maxCheckable":1 } ] }, { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"Back", "nextLabel":"Continue", "pageNumVisible":true, "canContinueAutomatically":false }, "pageNum":4, "elements":[ { "id":"2015c5d5-aa1b-4b00-bd7d-2cebeeceeb64", "type":"radioBox", "style":{ "options":{ }, "warning":{ }, "subtitle":{ }, "disclosure":{ }, "optionIcon":{ }, "optionLabel":{ } }, "isValid":true, "options":[ { "id":1, "label":"Emphasizes the emotional aspects of personal finance", "active":false }, { "id":2, "label":"Integrates spirituality into their coaching", "active":false }, { "id":3, "label":"Has a no-nonsense approach", "active":true }, { "id":4, "label":"Knows what it\u2019s like to be part of a minority community", "active":false }, { "id":5, "label":"Understands the life of a military family", "active":false } ], "warning":"Required", "subtitle":"Which coach persona profile resonates most with you?", "disclosure":"", "isRequired":true, "maxCheckable":1 } ] }, { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"Back", "nextLabel":"Continue", "pageNumVisible":true, "canContinueAutomatically":false }, "pageNum":5, "elements":[ { "id":"db0685f9-4fc2-453a-b06b-dc93f00f6c58", "type":"radioBox", "style":{ "options":{ }, "warning":{ }, "subtitle":{ }, "disclosure":{ }, "optionIcon":{ }, "optionLabel":{ } }, "isValid":true, "options":[ { "id":1, "label":"Security Keeper", "active":false }, { "id":2, "label":"Relationship Protector", "active":false }, { "id":3, "label":"Opportunity Seeker", "active":false }, { "id":4, "label":"Freedom Finder", "active":true }, { "id":5, "label":"Blended", "active":false } ], "warning":"Required", "subtitle":"What is your Financial Personality Type?", "disclosure":"", "isRequired":true, "maxCheckable":1 } ] }, { "header":{ "title":"Help your financial coach prepare" }, "actions":{ "backLabel":"Back", "nextLabel":"Finish", "pageNumVisible":true, "canContinueAutomatically":true }, "pageNum":6, "elements":[ { "id":"de308945-0498-4411-95ea-e4a369dbf5ac", "text":"", "type":"textArea", "style":{ "warning":{ }, "subtitle":{ }, "textArea":{ } }, "isValid":false, "minRows":1, "subtitle":"If your company banks with Traditions and is sponsoring Willow, please provide your company's name. (Optional)", "minLength":0, "isRequired":false, "placeholder":"Company name" } ] } ]
};

export const devEnterpriseProspectsListV3 = {
    "prospects": [
        {
            "contactId": 131,
            "consumerId": 1000,
            "firstName": "Jenna",
            "lastName": "Survey",
            "isArchived": false,
            "prospectId": 441,
            "prospectStageId": 217,
            "prospectStageName": "undefined",
            "advisor": {
                "advisorId": 42,
                "firstName": "Joe",
                "lastName": "Advisor"
            },
            "revenue": "0.00",
            "probabilityOfClosing": "30.00",
            "coaches": [],
            "nextSession": {"start": moment().add(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "lastSession": {"start": moment().subtract(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "memberOfGroups": null,
            "companyName": "My company",
            "wmcId": null,
            "isActive": true,
            "survey": null
        },
        {
            "contactId": 1311,
            "consumerId": 1009,
            "firstName": "Jenna",
            "lastName": "Survey2",
            "isArchived": false,
            "prospectId": 442,
            "prospectStageId": 217,
            "prospectStageName": "undefined",
            "advisor": null,
            "revenue": "0.00",
            "probabilityOfClosing": "30.00",
            "coaches": [],
            "nextSession": {"start": moment().add(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "lastSession": {"start": moment().subtract(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "memberOfGroups": null,
            "companyName": "My company",
            "wmcId": null,
            "isActive": true,
            "survey": null
        },
        {
            "contactId": 103,
            "consumerId": 10030,
            "firstName": "Jason",
            "lastName": "Aronson",
            "isArchived": true,
            "prospectId": 545,
            "prospectStageId": 217,
            "prospectStageName": "undefined",
            "advisor": {
                "advisorId": 42,
                "firstName": "Joe",
                "lastName": "Advisor"
            },
            "revenue": "100000.00",
            "probabilityOfClosing": "71.00",
            "coaches": [
                {
                    "coachId": 42,
                    "firstName": "Jane",
                    "lastName": "Coach",
                    "fullName": "Jane Coach",
                    "remainingSessions": 5,
                    "wmcId": 343
                },
                {
                    "coachId": 43,
                    "firstName": "Doe",
                    "lastName": "Coach",
                    "fullName": "Doe Coach",
                    "remainingSessions": 0,
                    "wmcId": null
                }
            ],
            "nextSession": null,
            "lastSession": {"start": moment().subtract(45, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "memberOfGroups": null,
            "companyName": "",
            "wmcId": 23,
            "survey": null,
            "isActive": true,
        }
    ]
};

export const devEnterpriseClientsistV2 = {
    "prospects": [
        {
            "contactId": 131,
            "consumerId": 1000,
            "firstName": "Jenna",
            "lastName": "Aronson",
            "isActive": false,
            "isArchived": false,
            "prospectId": 441,
            "prospectStageId": 132,
            "prospectStageName": "client",
            "advisor": {
                "advisorId": 42,
                "firstName": "Candice",
                "lastName": "McGarvey",
                "wmcId": null
            },
            "coaches": [],
            "nextSession": {"start": moment().add(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "lastSession": {"start": moment().subtract(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "memberOfGroups": null,
            "companyName": "Family business",
            "wmcId": 23
        },
        {
            "contactId": 103,
            "consumerId": 10030,
            "firstName": "Jason",
            "lastName": "Aronson",
            "isActive": true,
            "isArchived": true,
            "prospectId": 545,
            "prospectStageId": 132,
            "prospectStageName": "client",
            "advisor": {
                "advisorId": 42,
                "firstName": "Joe",
                "lastName": "Advisor",
                "wmcId": 5
            },
            "coaches": [
                {
                    "coachId": 42,
                    "firstName": "Jane",
                    "lastName": "Coach",
                    "fullName": "Jane Coach",
                    "remainingSessions": 8,
                    "wmcId": null
                },
                {
                    "coachId": 43,
                    "firstName": "Doe",
                    "lastName": "Coach",
                    "fullName": "Doe Coach",
                    "remainingSessions": 7,
                    "wmcId": 7
                }
            ],
            "nextSession": null,
            "lastSession": {"start": moment().subtract(45, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
            "memberOfGroups": null,
            "companyName": "",
            "wmcId": null
        }
    ]
};


export const devEnterpriseClientV2 = {
    "contactId": 131,
    "consumerId": 1000,
    "firstName": "Jenna",
    "lastName": "Aronson",
    "isArchived": false,
    "prospectId": 441,
    "prospectStageId": 132,
    "prospectStageName": "client",
    // "advisor": null,
    "advisor": {
        "advisorId": 42,
        "firstName": "Candice",
        "lastName": "McGarvey",
        "wmcId": 6
    },
    "coaches": [],
    "nextSession": {"start": moment().add(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
    "lastSession": {"start": moment().subtract(14, "days").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00")},
    "memberOfGroups": null,
    "companyName": "Family business",
    "wmcId": null,
    "isActive": true,
    "survey": null
};

export const devEnterpriseContactV2 = {
    "contactId":131,
    "firstName":"Jenna",
    "lastName":"Aronson",
    "email":"ivan.mitrovic+34@gmail.com",
    "phone":"5769878978",
    "timeZone":"eastern",
    "address1":null,
    "address2":null,
    "city":null,
    "state":null,
    "zipCode":null,
    "dateOfBirth":null,
    "maritalStatus":null,
    "assetEstimate":null,
    "companyName":null,
    "isArchived":false,
    "expertId":900,
    "expertFullName":"Jason Advisor 900",
    "businessUserId":null,
    "businessUserDetails":null,
    "prospectId":441,
    "consumerId":1000,
    "referralSource":"wmc",
    "prospectStatus":"Client",
    "memberOfGroups":null,
    "isActive":true,
    "coachAssignments":[
        {
            "coachId":44,
            "fullName":"Jason Expert 44",
            "coachWmc":null,
            "assignmentId":121
        }
    ]
}

export const devEnterpriseProspectsListV2 = [
    {
        "contactId": 131,
        "consumerId": 1000,
        "firstName": "Jenna",
        "lastName": "Aronson",
        "isArchived": false,
        "prospectId": 441,
        "prospectStatuses": [
            {
                "statusId": 586,
                "statusTypeId": 217,
                "expertId": 24324,
                "wmcId": 1,
                "title": "Identified"
            }
        ],
        "advisor": {
            "advisorId": 1,
            "firstName": "Jason",
            "lastName": "Aronson"
        },
        "coaches": [
            {
                "coachId": 1,
                "firstName": "Jennifer",
                "lastName": "Scheffer"
            }
        ],
        "lastSessions": [
            {
                "id": 389,
                "start": moment().add(14, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
                "wmcId": 1,
                "businessUserId": 1
            }
        ],
        "nextSessions": [
            {
                "id": 389,
                "start": moment().add(14, "hours").format("YYYY-MM-DD[T]HH:mm:ss[+]00:00"),
                "wmcId": 1,
                "businessUserId": 1
            }
        ]
    }
];

// Single object same as GET apiv1/coach/prospects/calls
export const devEnterpriseContactDetailsV2 = {
    "advisor": {},
    "assignedCoaches": [],
    "canceledFirstCall": false,
    "coachId": 900,
    "coachProspectStatusId": 239,
    "coachProspectStatusTitle": "undefined",
    "consumerId": 1001,
    "contactId": 132,
    "email": "ivan.mitrovic+jason1@gmail.com",
    "firstName": "Ivan",
    "id": 1001,
    "isArchived": false,
    "lastName": "Mitrovic",
    "lastSession": null,
    "lastSessions": [],
    "name": "Ivan Mitrovic",
    "nextSession": null,
    "nextSessions": [],
    "phone": "7777777724",
    "prospectId": 442,
    "prospectStatuses": [],
    "referralType": "wmc",
    "registeredOn": null,
    "sentInvitationsCount": 0,
    "statusNote": "",
    "statusOrderIndex": 4,
    "timeZone": "eastern",
};

export const formatClientsContactDev = (data, isWMC, inputData, user) => ({
    "contactId": data.contactId,
    "firstName": data.firstName,
    "lastName": data.lastName,
    "isArchived": data.isArchived,
    "businessUserId": null,
    "prospectId": data.prospectId,
    "consumerId": data.consumerId,
    "email": inputData.email,
    "phone": inputData.phone,
    "prospectStatus": "Client",
    "memberOfGroups": null,
    "referralSource": isWMC ? "wmc" : user.first + " " + user.last,
    "timeZone": inputData.timeZone
});

const formatProspectsContactDev = (data, isWMC, inputData, user) => ({
    "contactId": data.contactId,
    "firstName": data.firstName,
    "lastName": data.lastName,
    "isArchived": data.isArchived,
    "businessUserId": null,
    "prospectId": data.prospectId,
    "consumerId": data.consumerId,
    "email": inputData.email,
    "phone": inputData.phone,
    "prospectStatus": "Prospect",
    "memberOfGroups": null,
    "referralSource": isWMC ? "wmc" : user.first + " " + user.last,
    "timeZone": inputData.timeZone
});

export const devEnterpriseOneContact = async (data, contactId) => {
    let contactOne = null;
    const contacts = data.enterprise.contacts.get("contactsAll");
    if(contacts !== List()) {
        contactOne = await contacts.filter(c => {return(c.get("contactId") === contactId)}).get(0);
        if(contactOne !== null && contactOne !== undefined) {
            console.log(contactOne);
            return(contactOne.toJS());
        }
    } else {
        const isWMC = data.common.wmc.get("isWMC");
        const user = data.common.user.toJS();
        const prospects = data.enterprise.prospects.get("prospectsAll");
        if(prospects !== List()) {
            contactOne = await prospects.filter(c => {return(c.get("contactId") === contactId)}).get(0);
            if(contactOne !== null && contactOne !== undefined) {
                console.log(contactOne);
                return(formatProspectsContactDev(contactOne.toJS(), isWMC, {"email": "email/phone/tz works on prod", "phone": 9999999999, "timeZone": "eastern"}, user));
            }
        }
        const clients = data.enterprise.clientsList.get("clientsAll");
        if(clients !== List()) {
            contactOne = await clients.filter(c => {return(c.get("contactId") === contactId)}).get(0);
            if(contactOne !== null && contactOne !== undefined) {
                console.log(contactOne);
                return(formatClientsContactDev(contactOne.toJS(), isWMC, {"email": "email/phone/tz works on prod", "phone": 9999999999, "timeZone": "eastern"}, user));
            }
        }
    }
};

export const devEnterpriseCoachesAssignedToWMCData = {
    "allCoaches": [
        {
            'coachId': 42,
            'first': "Michelle",
            'last': "Clark",
            'phone': 9999999999,
            'email': "michelle@coaching.com",
            'photo': images.devDataCoachMichelleAvatar,
            'bio': "html string of bio",
            "contactId": 3,
            "expertCategories": [
                {"categoryId": 66, "categoryName": "Financial Coach"},
                {"categoryId": 20, "categoryName": "Financial Coach2"}
            ],
            "isActive": false
        },
        {
            'coachId': 43,
            'first': "Jennifer",
            'last': "Scheffer",
            'phone': 8888888888,
            'email': "jennifer@coaching.com",
            'photo': images.devDataCoachJenniferAvatar,
            'bio': "html string of bio",
            "contactId": 2,
            "expertCategories": [
                {"categoryId": 10, "categoryName": "Financial Coach"}
            ],
            "isActive": true
        }
    ] // Or empty []
};

export const devEnterpriseWMCProspectsCoachingData = {
    "allCoaches": [
        {
            'coachId': 42,
            'first': "Michelle",
            'last': "Clark",
            'phone': 9999999999,
            'email': "michelle@coaching.com",
            'photo': images.devDataCoachMichelleAvatar,
            'bio': "html string of bio",
            "remainingSessions": 3,
        },
        {
            'coachId': 43,
            'first': "Jennifer",
            'last': "Scheffer",
            'phone': 8888888888,
            'email': "jennifer@coaching.com",
            'photo': images.devDataCoachJenniferAvatar,
            'bio': "html string of bio",
            "remainingSessions": 0,
        }
    ]
};

export const devEnterpriseCoachProgramData = (source) => {
    if(source === "advisor") {
        return({
            "advisorSource": {
                'id': 3,
                'first': "Carl",
                'last': "Hall",
                'phone': 7777777777,
                'email': "carl@advisor.com",
                'photo': images.devDataAdvisorCarlAvatar,
                'bio': "html string of bio",
            },
            "coachSource": null,
            "sessionLength": "45-minutes",
            "remainingSessions": 0,
            "completedSessions": 3,
            "hoursInCoaching": 1.5,
            "purchaseDate": null,
            "package": null,
            "trialCallComplete": null,
            "wmc": 32,
            "wmcDetails": {
                "id": 32,
                "companyName": "Employers",
                "logoUrl": images.devDataAdvisorCarlAvatar
            },
        })
    } else if(source === "willow") {
        return ({
            "advisorSource": null,
            "coachSource": null,
            "sessionLength": "45-minutes",
            "remainingSessions": 1,
            "completedSessions": 3,
            "hoursInCoaching": 1.5,
            "purchaseDate": "2020-11-06T10:00:00+00:00",
            "package": "3-month", // "1-month", "3-month", "6-month", "12-month subscription", or "trial",
            "trialCallComplete": true
        })
    } else {
        return ({
            "advisorSource": {
                "id": 243241,
                "first": "Candice",
                "last": "McGarvey",
                'photo': images.devDataCoachMichelleAvatar,
            },
            "coachSource": {
                'id': 1,
                'first': "Michelle",
                'last': "Clark",
                'phone': 9999999999,
                'email': "michelle@coaching.com",
                'photo': images.devDataCoachMichelleAvatar,
                'bio': "html string of bio",
            },
            "sessionLength": "45-minutes",
            "remainingSessions": 0,
            "completedSessions": 3,
            "hoursInCoaching": 1.5,
            "purchaseDate": "2020-11-06T10:00:00+00:00",
            "package": "trial", // "1-month", "3-month", "6-month", "12-month subscription", or "trial",
            "trialCallComplete": true
        })
    }
};


export const devEnterpriseListings = {
    "financialCoachingPlans": [
        {
            "id": 1,
            "durationInMonths": 1,
            "coachingSessionsQuota": 1,
            "coachingSessionsLength": 15,
            "totalPriceAmount": 0,
            "monthlyPriceAmount": 0,
            "title": "Q&A Call",
            "description": "<p>A 15-minute introductory phone call for you to learn more.</p>",
            "coverPhotoUrl": null, //images.devDataTeamJasonAvatar,
            "orderIndex": 1,
            "status": "active",
            "terms": "https://"+env.URL.DOMAIN+"/terms-of-use",
            "privacy": "https://"+env.URL.DOMAIN+"/terms-of-use",
            "download": "https://"+env.URL.DOMAIN+"/",
            "serviceType": "meetings"
        },
        {
            "id": 2,
            "durationInMonths": 1,
            "coachingSessionsQuota": 2,
            "coachingSessionsLength": 120,
            "totalPriceAmount": 38900,
            "monthlyPriceAmount": 0,
            "title": "Clarity Meeting",
            "description": "<p>A 2-hour session designed to provide you with clear understanding of your financial picture. You’ll know which aspects of your personal finances are on track and what needs more attention. We’ll take a deep dive into your spending and show you where your money is going. You’ll receive customized recommendations related to savings, cash flow, debt, and protection that are designed to help you reach your goals.</p><br /><p>Please ensure that your spouse/partner is available on the date you select. We will email you pre-work to be returned 48 hours in advance of your scheduled meeting.</p>",
            "coverPhotoUrl": images.devDataTeamJasonAvatar,
            "orderIndex": 2,
            "status": "active",
            "terms": "https://"+env.URL.DOMAIN+"/terms-of-use",
            "privacy": null,
            "download": null,
            "serviceType": "download"
        }
    ]
};

export const devEnterpriseListing = {
    "id": 1,
    "durationInMonths": 3,
    "coachingSessionsQuota": 4,
    "totalPriceAmount": 30095,
    "monthlyPriceAmount": 10095,
    "title": "2020-08-06T1957 plan",
    "description": "<p>description</p>",
    "coverPhotoUrl": images.devDataTeamJasonAvatar,
    "orderIndex": 1,
    "status": "active"
};

export const devEnterpriseListingsOrder = (listingIds, listings) => {
    return listings.toJS().map(listing => {
        return {...listing, "orderIndex": (listingIds.indexOf(listing.id)+1)}
    })
};

export const devEnterpriseListingUpdated = (data) => ({
    "id": 1,
    "durationInMonths": 3,
    "coachingSessionsQuota": 4,
    "totalPriceAmount": 30095,
    "monthlyPriceAmount": 10095,
    "title": data.title,
    "description": data.description,
    "coverPhotoUrl": data.coverPhotoUrl,
    "orderIndex": 1,
    "status": data.status
});

export const devEnterpriseListingCreated = (data, listings) => ({
    "id": randomNumber(),
    "durationInMonths": data.durationInMonths,
    "coachingSessionsQuota": data.quota,
    "totalPriceAmount": data.totalPriceAmount,
    "monthlyPriceAmount": data.totalPriceAmount/data.durationInMonths,
    "title": data.title,
    "description": data.description,
    "coverPhotoUrl": data.coverPhotoUrl,
    "orderIndex": (listings.size+1),
    "status": data.status
});

/* Middleware - tryGetSettingsPersonalInfo */
export const devSettingsPersonalInfoData = {
    "first": 'Jason',
    "last": 'Aronson',
    "phone": '5552523253',
    "email": 'jason@coolcoaches.com',
    "timeZone": 'eastern',
    "companyName": "Willow Network, Inc."
};

export const devSettingsPersonalInfoUpdateData = (data) => ({
    "first": data.first,
    "last": data.last,
    "phone": data.phone,
    "email": data.email,
    "timeZone": data.timeZone,
    "companyName": data.companyName
});
